import { COLORS } from "./index"

export const levelcolors = [
    {
        bgColor: COLORS.level_one,
        color: COLORS.level_one_text
    },
    {
        bgColor: COLORS.level_two,
        color: COLORS.level_two_text
    },
    {
        bgColor: COLORS.level_three,
        color: COLORS.level_three_text
    },
    {
        bgColor: COLORS.level_four,
        color: COLORS.level_four_text
    },
    {
        bgColor: COLORS.level_five,
        color: COLORS.level_five_text
    },
    {
        bgColor: COLORS.level_six,
        color: COLORS.level_six_text
    }
]